{
  "type": "object",
  "properties": {
    "Manufacturer": { "type": "string", "minLength": 1 },
    "ManufacturersModelName": { "type": "string", "minLength": 1 },
    "Units": {
      "type": "string",
      "minLength": 1
    },
    "TracerName": { "type": "string", "minLength": 1 },
    "TracerRadionuclide": { "type": "string", "minLength": 1 },
    "InstitutionName": { "type": "string", "minLength": 1 },
    "InstitutionAddress": { "type": "string", "minLength": 1 },
    "InstitutionalDepartmentName": {
      "$ref": "common_definitions.json#/definitions/InstitutionalDepartmentName"
    },
    "BodyPart": { "type": "string", "minLength": 1 },
    "TracerRadLex": { "type": "string", "minLength": 1 },
    "TracerSNOMED": { "type": "string", "minLength": 1 },
    "TracerMolecularWeight": { "type": "number" },
    "TracerMolecularWeightUnits": { "type": "string", "minLength": 1 },
    "PharmaceuticalName": { "type": "string", "minLength": 1 },
    "PharmaceuticalDoseAmount": {
      "anyOf": [
        { "type": "number", "minimum": 0 },
        { "type": "array", "items": { "type": "number" } }
      ]
    },
    "PharmaceuticalDoseUnits": { "type": "string", "minLength": 1 },
    "PharmaceuticalDoseRegimen": { "type": "string", "minLength": 1 },
    "PharmaceuticalDoseTime": {
      "anyOf": [
        { "type": "number" },
        { "type": "array", "items": { "type": "number" } }
      ]
    },
    "Anaesthesia": { "type": "string", "minLength": 1 },

    "ModeOfAdministration": { "type": "string", "minLength": 1 },
    "InjectedRadioactivity": { "type": "number" },
    "InjectedRadioactivityUnits": { "type": "string", "minLength": 1 },
    "InjectedMass": {
      "anyOf": [{ "type": "number" }, { "type": "string", "pattern": "^n/a$" }]
    },
    "InjectedMassUnits": { "type": "string", "minLength": 1 },
    "SpecificRadioactivity": {
      "anyOf": [{ "type": "number" }, { "type": "string", "pattern": "^n/a$" }]
    },
    "SpecificRadioactivityUnits": { "type": "string", "minLength": 1 },
    "InjectedMassPerWeight": { "type": "number" },
    "InjectedMassPerWeightUnits": { "type": "string", "minLength": 1 },
    "SpecificRadioactivityMeasTime": {
      "type": "string",
      "pattern": "^(?:2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9]$"
    },
    "MolarActivity": { "type": "number" },
    "MolarActivityUnits": { "type": "string", "minLength": 1 },
    "MolarActivityMeasTime": {
      "type": "string",
      "pattern": "^(?:2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9]$"
    },
    "InfusionRadioactivity": { "type": "number" },
    "InfusionStart": { "type": "number" },
    "InfusionSpeed": { "type": "number" },
    "InfusionSpeedUnits": { "type": "string", "minLength": 1 },
    "InjectedVolume": { "type": "number" },
    "Purity": { "type": "number" },

    "TimeZero": {
      "type": "string",
      "pattern": "^(?:2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9]$"
    },
    "ScanStart": { "type": "number" },
    "InjectionStart": { "type": "number" },
    "FrameTimesStart": { "type": "array", "items": { "type": "number" } },
    "FrameDuration": { "type": "array", "items": { "type": "number" } },
    "ScanDate": {
      "type": "string",
      "pattern": "date"
    },
    "InjectionEnd": { "type": "number" },

    "AcquisitionMode": { "type": "string", "minLength": 1 },
    "ImageDecayCorrected": { "type": "boolean" },
    "ImageDecayCorrectionTime": { "type": "number" },
    "ReconMethodName": { "type": "string", "minLength": 1 },
    "ReconMethodParameterLabels": {
      "type": "array",
      "items": { "type": "string" }
    },
    "ReconMethodParameterUnits": {
      "type": "array",
      "items": { "type": "string" }
    },
    "ReconMethodParameterValues": {
      "type": "array",
      "items": { "type": "number" }
    },
    "ReconFilterType": {
      "anyOf": [
        { "type": "string" },
        { "type": "array", "items": { "type": "string" } }
      ]
    },
    "ReconFilterSize": {
      "anyOf": [
        { "type": "number", "minimum": 0 },
        { "type": "array", "items": { "type": "number" } }
      ]
    },
    "ReconMethodImplementationVersion": { "type": "string", "minLength": 1 },
    "AttenuationCorrection": { "type": "string", "minLength": 1 },
    "AttenuationCorrectionMethodReference": {
      "type": "string",
      "minLength": 1
    },
    "ScaleFactor": {
      "type": "array",
      "items": { "type": "number" }
    },
    "ScatterFraction": {
      "type": "array",
      "items": { "type": "number" }
    },
    "DecayCorrectionFactor": {
      "type": "array",
      "items": { "type": "number" }
    },
    "DoseCalibrationFactor": {
      "type": "number",
      "items": { "type": "number" }
    },
    "PromptRate": {
      "type": "array",
      "items": { "type": "number" }
    },
    "RandomRate": {
      "type": "array",
      "items": { "type": "number" }
    },
    "SinglesRate": {
      "type": "array",
      "items": { "type": "number" }
    },
    "CogAtlasID": { "$ref": "common_definitions.json#/definitions/CogAtlasID" },
    "CogPOID": { "$ref": "common_definitions.json#/definitions/CogPOID" },
    "TaskName": {
      "type": "string"
    },
    "TaskDescription": {
      "$ref": "common_definitions.json#/definitions/TaskDescription"
    },
    "Instructions": {
      "$ref": "common_definitions.json#/definitions/Instructions"
    }
  },

  "required": [
    "Manufacturer",
    "ManufacturersModelName",
    "Units",
    "TracerName",
    "TracerRadionuclide",

    "ModeOfAdministration",
    "InjectedRadioactivity",
    "InjectedRadioactivityUnits",
    "InjectedMass",
    "InjectedMassUnits",
    "SpecificRadioactivity",
    "SpecificRadioactivityUnits",

    "TimeZero",
    "ScanStart",
    "InjectionStart",
    "FrameTimesStart",
    "FrameDuration",

    "AcquisitionMode",
    "ImageDecayCorrected",
    "ImageDecayCorrectionTime",
    "ReconMethodName",
    "ReconMethodParameterLabels",
    "ReconFilterType",
    "AttenuationCorrection"
  ],
  "allOf": [
    {
      "$ref": "#/dependency-definitions/if-ReconMethodParameterLabels-then-Units-and-Values"
    },
    {
      "$ref": "#/dependency-definitions/if-bolus-infusion-then-infusion-details"
    },
    {
      "$ref": "#/dependency-definitions/if-ReconFilterType-then-ReconFilterSize"
    }
  ],
  "dependencies": {
    "TracerMolecularWeight": ["TracerMolecularWeightUnits"],
    "InjectedRadioactivity": ["InjectedRadioactivityUnits"],
    "InjectedMassPerWeight": ["InjectedMassPerWeightUnits"],
    "MolarActivity": ["MolarActivityUnits"],
    "InfusionSpeed": ["InfusionSpeedUnits"],
    "ReconMethodParameterLabels": [
      "ReconMethodParameterUnits",
      "ReconMethodParameterValues"
    ]
  },
  "dependency-definitions": {
    "if-ReconMethodParameterLabels-then-Units-and-Values": {
      "if": {
        "type": "object",
        "properties": {
          "ReconMethodParameterLabels": { "const": "none" }
        },
        "required": ["ReconMethodParameterLabels"]
      },
      "then": {},
      "else": {
        "required": ["ReconMethodParameterUnits", "ReconMethodParameterValues"]
      }
    },
    "if-bolus-infusion-then-infusion-details": {
      "if": {
        "type": "object",
        "properties": {
          "ModeOfAdministration": { "const": "bolus-infusion" }
        },
        "required": ["ModeOfAdministration"]
      },
      "then": {
        "required": [
          "InfusionRadioactivity",
          "InfusionStart",
          "InfusionSpeed",
          "InfusionSpeedUnits",
          "InjectedVolume"
        ]
      }
    },
    "if-ReconFilterType-then-ReconFilterSize": {
      "if": {
        "type": "object",
        "properties": {
          "ReconFilterType": { "const": "none" }
        },
        "required": ["ReconFilterType"]
      },
      "then": {},
      "else": { "required": ["ReconFilterSize"] }
    }
  }
}
